import $$ from "cmn-utils";

const baseUrl = "/api/device/alarm/";
export default {
  exportExcel: (params) => {
    return $$.get(baseUrl + "export-excel", params);
  },
  list: (params) => {
    return $$.get(baseUrl + "list", params);
  },
  get: (params) => {
    return $$.get(baseUrl + "get", params);
  },
  total: (params) => {
    return $$.get(baseUrl + "total", params);
  },
  delete: (params) => {
    return $$.post(baseUrl + "delete", params);
  },
};
